import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {COMMA, ENTER, TAB} from '@angular/cdk/keycodes';
import {AbstractControl, FormControl, UntypedFormGroup} from '@angular/forms';
import {map, startWith, timeout} from 'rxjs/operators';
import {MatChipInput, MatChipInputEvent} from '@angular/material/chips';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {Observable} from 'rxjs';
import {SelectElement} from '../../../../components/common/select/select.model';
import {Moment} from 'moment';
import {MomentAdapter} from '../../../../shared/utils/moment.utils';

@Component({
  selector: 'app-chips-autocomplete',
  templateUrl: './chips-autocomplete.component.html',
  styles: [
  ]
})
export class ChipsAutocompleteComponent implements OnInit{

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() noEntriesFoundLabel = 'Aucun éléments trouvé';
  @Input() placeHolderLabel: string;
  @Input() parentFormControlName: string;
  @Input() elements: SelectElement[] = [];
  @Input() loading = false;
  @Input() loadingError: any;
  @Input() maxValues: number;

  internalControl = new FormControl('');
  separatorKeysCodes: number[] = [ENTER, COMMA, TAB];
  filteredElements: Observable<SelectElement[]>;
  lastSelectedOptionTime: Moment;

  @ViewChild('input') fruitInput: ElementRef<HTMLInputElement>;

  constructor() {
  }

  ngOnInit() {
    this.filteredElements = this.internalControl.valueChanges.pipe(
        startWith(null),
        map((fruit: string | null) => (fruit ? this._filter(fruit) : this.elements.slice())),
    );
  }

  add(value: string): void {
    console.log(['add', value]);
    value = (value || '').trim();
    if (value) {
      if (!this.selectedValues.includes(value)) {
        const selectedValues = this.selectedValues.filter(value1 => value1);
        selectedValues.push(value);
        this.control.setValue(selectedValues);
      }
    }
    this.internalControl.setValue(null);
    this.fruitInput.nativeElement.value = '';
  }

  addOnBlur(event: FocusEvent) {
    console.log(['addOnBlur', event]);
    setTimeout(() => {
      if (!this.lastSelectedOptionTime || MomentAdapter.current().get().diff(this.lastSelectedOptionTime) > 300) {
        this.add( this.fruitInput.nativeElement.value);
      }
      }, 300);
  }

  remove(value: string): void {
    this.control.setValue(this.selectedValues.filter(value1 => value1 !== value));
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(['selected', event]);
    const selectedValues = this.selectedValues.filter(value1 => value1);
    selectedValues.push(event.option.viewValue);
    this.fruitInput.nativeElement.value = '';
    this.internalControl.setValue(null);
    this.control.setValue(selectedValues);
  }

  private _filter(value: string): SelectElement[] {
    const filterValue = value.toLowerCase();

    return this.elements.filter(element => {
      return !value || value.trim() === '' || element.label.toLowerCase().includes(filterValue);
    });
  }

  get control(): AbstractControl {
    return this.parentFormGroup.get(this.parentFormControlName);
  }

  get selectedValues(): string[] {
    const value = this.control.value;
    return value ? value as string[] : [];
  }

  resolveReadableValue(value: string) {
    const selectElement = this.elements.find(value1 => value1.value === value);
    return selectElement ? selectElement.label : value;
  }

}
